const DOMAINS: Record<string, string> = {
  'status-alteracao-cadastral': '@status.alteracao-cadastral',
  'status-exclusao-beneficiario': '@status.exclusao-beneficiario',
  'stipulator-carater-internacao': '@stipulator.d-carater-internacao',
  'stipulator-regime-internacao': '@stipulator.d-regime-internacao',
  'stipulator.status-mensalidade': '@stipulator.status-mensalidade',
  'stipulator-tipo-guia': '@stipulator.d-tipo-guia',
  'stipulator-tipos-consulta': '@stipulator.d-tipos-consulta',
  'stipulator-tipo-atendimento': '@stipulator.d-tipo-atendimento',
  'stipulator-estagio-requisicao': '@stipulator.estagio-requisicao',
};

export default DOMAINS;
